<template>
  <div>
    <Header />
    <slot />
    <Footer />
  </div>
</template>

<script>
import Header from 'components/layouts/application/Header.vue'
import Footer from 'components/layouts/application/Footer.vue'

export default {
  name: 'ApplicationLayout',

  components: {
    Header,
    Footer,
  },
}
</script>
